{
  "version": 1,
  "asset_id": "eed6c814-2ac3-4e88-8330-29591b5a0df3",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/eed6c814-2ac3-4e88-8330-29591b5a0df3/ai-search-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/eed6c814-2ac3-4e88-8330-29591b5a0df3/ai-search-640.avif",
  "original_filename": "ai-search-640.avif",
  "size": 15143,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:45Z"
}
